import React, { memo } from 'react';
import classNames from 'classnames';
import cls from '../MassActionsPanel.module.css';
import { useCopyBlock } from './useCopyBlock';

export const CopyBlock = memo(({ setActiveSelect, activeSelect }) => {
    const { clonePositions, clonePositionsToDirectory } = useCopyBlock(setActiveSelect);

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                if (activeSelect === 'copy') {
                    setActiveSelect('');
                } else {
                    setActiveSelect('copy');
                }
            }}
            className={cls.select}
        >
            <span>{i18next.t('CopyBlock.copyBtn.text')}</span>
            <div
                className={classNames(cls.svgWrapper, {
                    [cls.active]: activeSelect === 'copy',
                })}
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.95316 6.33337L3.95316 7.33337L8.00003 11.3802L12.0469 7.33337L11.0469 6.33337L8.00003 9.38025L4.95316 6.33337Z"
                        fill="white"
                    />
                </svg>
            </div>
            <div
                className={classNames(cls.actionsGroupList, {
                    [cls.activeList]: activeSelect === 'copy',
                })}
            >
                <div onClick={(e) => clonePositions(e)} className={cls.listItem}>
                    {i18next.t('CopyBlock.clonePositions.text')}
                </div>
                {!isGeneralDirectory && (
                    <div onClick={(e) => clonePositionsToDirectory(e)} className={cls.listItem}>
                        {i18next.t('CopyBlock.clonePositionsToDirectory.text')}
                    </div>
                )}
            </div>
        </button>
    );
});
